export const phrasesPt = [
  "Você não precisa se acalmar antes de seguir em frente.",
  "A vergonha não é prova de fraqueza, mas sim prova de que você se importa em pertencer a um grupo.",
  "A mente te engana com uma voz que parece verdadeira.",
  "Evitação reduz a sua vida, enquanto aceitação a expande.",
  "A ansiedade e a excitação são sentidas de forma quase idêntica no corpo.",
  "Você não precisa de confiança para a ação; a ação cria confiança.",
  "O medo aparece quando você chega próximo do que importa.",
  "Controle é o problema, não a solução.",
  "Não é sobre o que você pensa, mas o que você faz na presença do que você pensa.",
  "A meta não é se sentir melhor, mas viver melhor.",
  "Você não precisa esperar até que tudo fique claro. Tome uma pequena ação alinhada com as qualidades que te interessam, ainda hoje.",
  "A ansiedade é o preço a pagar por uma vida com significado.",
  "Você não é seus sentimentos, você é quem os percebe.",
];

export const phrasesEn = [
  "You do not need to calm down before moving forward.",
  "Shame is not proof of weakness, but proof that you care about belonging.",
  "The mind can mislead you with a voice that sounds true.",
  "Avoidance shrinks your life, while acceptance expands it.",
  "Anxiety and excitement are felt almost identically in the body.",
  "You do not need confidence to act; action creates confidence.",
  "Fear shows up when you get close to what matters.",
  "Control is the problem, not the solution.",
  "It is not about what you think, but what you do in the presence of what you think.",
  "The goal is not to feel better, but to live better.",
  "You do not need to wait until everything is clear. Take one small action aligned with the qualities that matter to you—today.",
  "Anxiety is the price of a meaningful life.",
  "You are not your feelings; you are the one who notices them.",
];
